// Copyright Robert Bosch GmbH. All rights reserved, also regarding any disposal, exploration, reproduction,
// editing, distribution, as well as in the event of applications for industrial property rights.
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";
import MomentUtils from "@date-io/moment";
import Divider from "@material-ui/core/Divider";
import MuiDialogActions from "@material-ui/core/DialogActions";import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import {
  updateBreadcrumbs,
  updateToasterConfig,
} from "../../../redux/modules/app/actions";
import listviewUseStyles from "./style";
import Loader from "../../../Components/Preloader/index";
import httpRequest from "../../../Utils/httpRequest";
import UrlConfig from "../../../Constants/apiUrls";
import { tempAccessListHeaderCell } from "../../../Data/report-page";
import Pagination from "@material-ui/lab/Pagination";
import deleteIcon from "../../../Assets/icons/deleteIcon.png";
import IconButton from "@mui/material/IconButton";
import EditIcon from "../../../Assets/Images/edit.png";
import synced from "../../../Assets/Images/live.png";
import notSynced from "../../../Assets/Images/Non-Sync.png";
import syncPending from "../../../Assets/Images/Sync_pending.svg";
import syncAll from "../../../Assets/Images/resync_all.svg";
import add from '../../../Assets/Images/add_icon.svg'
import Download from "../../../Assets/icons/download_icon.svg";
import syncImage from "../../../Assets/Images/sync.svg";
import { withStyles } from "@material-ui/core";
import { getCookie } from "../../../Utils/cookies";
import { accessControlManagementFilters } from "../../../Constants/appConstants";
import "./style.scss";

//@component
//TempAccessListView
function TempAccessListView(props) {
  const classes = listviewUseStyles();

  const [viewList, setViewList] = useState([]);
  const [parkList, setParkList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  //const [tableDataNotFound, setTableDataNotFound] = useState("");
  const [responseDataNotFound, setResponseDataNotFound] = useState("");
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("datetime");
  const [pageNumber, setPagenumber] = useState(
    props.location.state?.back === "true" ? props.location.state?.loadpage : 0
  );
  const [searchKey, setSearchKey] = useState(
    props.location.state?.searchKey ? props.location.state?.searchKey : ""
  );
  const [searchFlag, setSearchFlag] = useState(false);
  const [postsPerPage, setpostsPerPage] = useState(
    Number(accessControlManagementFilters.pageSizes[0])
  );
  const [totalPages, setTotalPages] = useState(0);
  //const [internetFlag, setInternetFlag] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("");
  const [responseType, setresponseType] = useState("");
  const [falseList, setfalseList] = useState(0);
  const [syncpass, setsyncpass] = useState(0);
  const [syncfail, setsyncfail] = useState(0);
  const [syncMode, setSyncMode] = useState("");
  const [syncResponseMessage, setSyncResponseMessage] = useState("");
  const [syncTotalRecords, setSyncTotalRecords] = useState(0);
  const [sourceTypeFilter, setSourceTypeFilter] = useState([]);
  const [syncStatusFilter, setSyncStatusFilter] = useState([]);
  const [parkingSpaceList, setParkingSpaceList] = useState([]);
  const [parkingIdFilter, setParkingIdFilter] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [organizationName, setOrganizationName] = useState("");
  const [hasInteracted, setHasInteracted] = useState(false);
  const [isReportDownloading, setIsReportDownloading] = useState(false);
  const [isReportEnabled, setIsReportEnabled] = useState(false);
  const [showNoRecordsMessage, setShowNoRecordsMessage] = useState(false);
  //const [noSearch, setNosearch] = useState(false);

  // const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // const prevCount = usePrevious(searchKey)

  const inputRef = useRef();
  const isInitialMount = useRef(true);
  const pageNumberRef = useRef(pageNumber);
  const getTempAccessListRef = useRef(null);
  const pollIntervalRef = useRef(null);
  // only show "no search results" dialog after Generate/search, not on default/initial load
  const shouldShowSearchFailDialogRef = useRef(false);
  const BULK_JOB_STORAGE_KEY = "tempAccessBulkDownloadJobId";
  //mui custom styling
  const DialogActions = withStyles(() => ({
    root: {
      padding: "8px 0px !important",
    },
  }))(MuiDialogActions);

  const formatFilterDate = (dateValue) => {
    if (!dateValue) {
      return "";
    }
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) {
      return "";
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const allParkingIds = parkingSpaceList
    .filter((list) => list.parkingId)
    .map((list) => list.parkingId);

  const hasActiveFilters = () =>
    searchKey !== "" ||
    sourceTypeFilter.length > 0 ||
    syncStatusFilter.length > 0 ||
    parkingIdFilter.length > 0 ||
    fromDate !== null ||
    toDate !== null;

  const buildListParams = (page) => {
    const trimmedSearch = (searchKey || "").trim();
    return {
      page: page,
      size: postsPerPage,
      searchData: trimmedSearch.length >= 3 ? trimmedSearch : "",
      sourceType: sourceTypeFilter.filter((v) => v !== "1"),
      syncStatus: syncStatusFilter.filter((v) => v !== "1"),
      parkingIds: parkingIdFilter.filter((v) => v !== "all"),
      startDate: formatFilterDate(fromDate),
      endDate: formatFilterDate(toDate),
    };
  };

  const isInvalidDateRange = () => {
    const start = formatFilterDate(fromDate);
    const end = formatFilterDate(toDate);
    return Boolean(start && end && start > end);
  };

  const showInvalidDateRangeError = () => {
    props.dispatch(
      updateToasterConfig({
        show: true,
        message: "From Date cannot be after To Date",
        color: "red",
      })
    );
  };

  // while component is loading this api is called
  const getTempAccessList = (page) => {
    //console.log("previous value", searchKey, prevCount)
    httpRequest.get(
      "tempAccessListView",
      {
        "Content-Type": "application/json",
      },
      successCallbackList,
      errorCallbackList,
      buildListParams(page)
    );
  };
  pageNumberRef.current = pageNumber;
  getTempAccessListRef.current = getTempAccessList;

  // success callback for get list
  const successCallbackList = (jsonResponse) => {
    if (jsonResponse.data?._embedded.results.length === 0) {
      //setTableDataNotFound("No data here");
      setfalseList(0);
      setIsLoading(false);
      setPagenumber(0);
      setTotalPages(1);
      setOrganizationName("");
      // empty default/initial list should not use the search-fail dialog,
      // otherwise OK reloads defaults and loops
      if (shouldShowSearchFailDialogRef.current) {
        setResponseDataNotFound("No data here");
        setDialogOpen(true);
        setresponseType("searchFail");
        setShowNoRecordsMessage(false);
      } else {
        setResponseDataNotFound("");
        setresponseType("");
        setDialogOpen(false);
        setShowNoRecordsMessage(true);
      }
    } else {
      setResponseDataNotFound("");
      setresponseType("");
      setShowNoRecordsMessage(false);
      const firstOrg =
        jsonResponse.data?._embedded?.results?.[0]?.organizaionName ||
        jsonResponse.data?._embedded?.results?.[0]?.organizationName ||
        "";
      setOrganizationName(firstOrg);
    }
    //setTableDataNotFound("");
    setPagenumber(jsonResponse.data.page.number);
    setViewList(jsonResponse.data?._embedded.results);
    setTotalPages(jsonResponse.data.page.totalPages);
    // setTotalElements(jsonResponse.data.page.totalElements);
    //setInternetFlag(false);
    setIsLoading(false);
    setfalseList(0);
    // setNosearch(false)
  };

  // error callback for get list
  console.log(responseType);
  const errorCallbackList = (error) => {
    if (error) {
      setIsLoading(false);
      if (shouldShowSearchFailDialogRef.current) {
        setDialogOpen(true);
        setResponseDataNotFound("No data here");
        setresponseType("searchFail");
        setShowNoRecordsMessage(false);
      } else {
        setDialogOpen(false);
        setResponseDataNotFound("");
        setresponseType("");
        setShowNoRecordsMessage(true);
      }
      //setInternetFlag(false);
    }
  };
  // callback api call when pagination button is clicked
  const pageHandler = (number) => {
    setIsLoading(true);
    let pagenumber = number || 0;
    //console.log("page number", pagenumber)

    httpRequest.get(
      "tempAccessListView",
      {
        "Content-Type": "application/json",
      },
      successCallbackList,
      errorCallbackList,
      buildListParams(pagenumber)
    );
  };
  // when pagination button is clicked here page number is set and api callback is triggered
  const handleChange = (event, value) => {
    // if (noSearch){
    //   setDialogOpen(true)
    //   setresponseType('searchFail')

    // }
    let currpage;
    currpage = value - 1;
    pageHandler(currpage);
  };
  // when component loading it updates breadcrumb and loads the table by default
  const { dispatch } = props;
  useEffect(() => {
    dispatch(updateBreadcrumbs("tempaccesslistview"));
    setIsLoading(true);
    shouldShowSearchFailDialogRef.current = false;
    getTempAccessListRef.current(pageNumberRef.current);
    httpRequest.get(
      "parkingListDashboard",
      {},
      (jsonResponse) => {
        setParkingSpaceList(jsonResponse?.data?._embedded?.results || []);
      },
      () => {
        setParkingSpaceList([]);
      },
      {}
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);


  //show resync-all only when at least one row is Pending(0) or Failure(2)
  //ignore rows with a missing/empty syncStatus, otherwise Number(null)/Number("")
  //coerce to 0 and keep the icon visible even when all loaded rows are synced
  const hasUnsyncedRows = viewList.some((row) => {
    const status = row?.syncStatus;
    if (status === null || status === undefined || status === "") {
      return false;
    }
    return [0, 2].includes(Number(status));
  });

  //function for table header arrow functionality and datestamp sort api call
  function EnhancedTableHead(props) {
    const { classes } = props;
    // const createSortHandler = (property) => (event) => {
    //   onRequestSort(event, property);
    // };
    return (
      <TableHead>
        <TableRow>
          {tempAccessListHeaderCell.map((headCell) =>
            headCell.id !== "resyncstatus" ? (
              <TableCell
                key={headCell.id}
                align={
                  headCell.id === "sno" ||
                  headCell.id === "syncstatus" ||
                  headCell.id === "actions"
                    ? "center"
                    : "left"
                }
                width={headCell.width}
                className={classes.thData}
              >
                {headCell.label}
              </TableCell>
            ) : (
              <TableCell
                key={headCell.id}
                width={headCell.width}
                className={classes.thheadDataSyncCall}

              >
                {hasUnsyncedRows && (
                  <IconButton aria-label="sync" className={classes.resyncButton} onClick={handleResyncAll}>
                    <img alt="sync" src={syncAll} className={classes.edit_icon} />
                  </IconButton>
                )}
              </TableCell>
            )
          )}
        </TableRow>
      </TableHead>
    );
  }
  //propTypes for table header arrow function
  EnhancedTableHead.propTypes = {
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
  };
  //table header arrow sub-function
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  // on clicking upload user button it redirects to upload page
  const uploadHandler = () => {
    props.history.push({
      pathname: "/portal/tempaccessbulkupload",
    });
  };
  // const syncHandler = () => {
  //   setIsLoading(true);
  //   httpRequest.get(
  //     "tempAccessListViewSync",
  //     {
  //       "Content-Type": "application/json",
  //     },
  //     successCallbacksynclist,
  //     errorCallbackList,
  //     {}
  //   );
  // };
  // eslint-disable-next-line no-unused-vars
  const manualSync = (data) => {
    httpRequest.patch(
      "manualtempAccessSync",
      data,
      {},
      successCallbacksync,
      errorCallbacksync,
      {}
    );
  };
  const successCallbacksync = (jsonResponse) => {
    setIsLoading(false);
    setDialogOpen(true);
    setresponseType("success");
    setsyncpass(jsonResponse.data?.noOfVehicleSynced);
    setsyncfail(jsonResponse.data?.noOfVehicleNotSynced);
    setSyncResponseMessage(jsonResponse.data?.responseMessage);
    setSyncTotalRecords(jsonResponse.data?.totalRecordsProcessed);
  };
  const errorCallbacksync = () => {
    setIsLoading(false);
    setDialogOpen(true);
    setresponseType("fail");
  };
  // const successCallbacksynclist = (jsonResponse) => {
  //   let data = [];
  //   let count = 0;
  //   jsonResponse.data._embedded.results.map((vehicles) => {
  //     if (vehicles.syncStatus === false) {
  //       count = count + 1;
  //       data.push({
  //         // "accessControlId": vehicles.accessControlId,
  //         vehicleNumber: vehicles.vehicleNumber,
  //       });
  //     }
  //   });
  //   data.toString();
  //   //console.log(typeof(data))
  //   setfalseList(count);
  //   manualSync(data);
  // };
  //close dialog and refresh
  const closeRefresh = () => {
    setIsLoading(false);
    getTempAccessList(0);
    setresponseType("");
    setDialogOpen(false);
  };

  // when we click on confirm button in delete popup
  const submitDetails = () => {
    setIsLoading(true);
    httpRequest.deleteData(
      "deleteTempAccessUser",
      {
        parkingIds: deleteId,

        vehicleNumber: dialogTitle,
        adminRemarks: "manual deletion of Vehicle access",
      },
      {
        "Content-Type": "application/json",
      },
      successCallbackDelete,
      errorCallbackDelete,
      {}
    );
    setDialogOpen(false);
  };
  // user delete success callback
  const successCallbackDelete = (jsonResponse) => {
    if (jsonResponse) {
      setViewList([]);

      setDeleteId([]);

      // setresponseType("searchFail");
      // console.log(viewList);

      props.dispatch(
        updateToasterConfig({
          show: true,
          message: `Vehicle Access removed for the selected parking spaces`,
          color: "green",
        })
      );

      if (searchKey === "") {
        getTempAccessList(pageNumber);
      }

      if (searchKey !== "") {
        setIsLoading(false);
      }
    }
  };
  // user delete error callback
  const errorCallbackDelete = (error) => {
    setIsLoading(false);
    setDeleteId([]);
    if (error) {
      props.dispatch(
        updateToasterConfig({
          show: true,
          message: error.error_description || error.message || error.error,
          color: "red",
        })
      );
    }
  };
  // when we click on delete icon
  const deleteHandler = (id, vehicle) => {
    // setDeleteId(id);

    //setDialogRole(orgname)
    setDialogTitle(vehicle);
    //setDialogEmail(email);
    setIsLoading(true);

    // if (props.location.state) {
    httpRequest.get(
      "viewtempaccountdetails",

      {
        "Content-Type": "application/json",
      },
      successCallbackdetails,
      errorCallbackDetails,
      {
        vehicle: vehicle,
      }
    );
  };

  //getting parking list
  const successCallbackdetails = async (jsonResponse) => {
    setIsLoading(false);
    setDialogOpen(true);
    setParkList(jsonResponse.data?.accessedParkingList);
    // console.log(jsonResponse.data?.accessedParkingList)
    // getTempAccessList(jsonResponse.data?.accessedParkingList);
  };

  //getting parking list error
  const errorCallbackDetails = (error) => {
    setIsLoading(false);
    if (error) {
      props.dispatch(
        updateToasterConfig({
          show: true,
          message: error.error_description || error.message || error.error,
          color: "red",
        })
      );
    }
  };
  //checkbox to select parking handler

  const deleteParkingHandler = (id) => {
    if (deleteId.includes(id)) {
      let index = deleteId.indexOf(id);
      let numberOfElementToRemove = 1;
      if (index !== -1) {
        deleteId.splice(index, numberOfElementToRemove);
      }
    } else deleteId.push(id);
  };

  //function to capture and pass user id between components
  const viewHandler = (data1, data2) => {
    console.log("viewid", data1);
    props.history.push({
      pathname: "/portal/viewtempaccountdetails",
      state: {
        vehicleNumber: data1,
        userId: data2,
        page: pageNumber,
        searchKey: searchKey,
        //  currentPage: currentPage
      },
    });
  };

  //handle search change
  const handleSearchKeyChange = (e) => {
    setSearchKey(e.target.value);
    setHasInteracted(true);
  };

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    getTempAccessListRef.current(pageNumberRef.current);
  }, [searchFlag]);

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(?:".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  useEffect(() => {
    if (!hasInteracted) return;
    setIsLoading(true);
    inputRef.current.focus();
    httpRequest.get(
      "tempAccessListView",
      {
        "Content-Type": "application/json",
      },
      successCallbackList,
      errorCallbackList,
      buildListParams(pageNumber)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postsPerPage]);

  //handle search
  const handleSearchKey = () => {
    if (isInvalidDateRange()) {
      showInvalidDateRangeError();
      return;
    }
    const email = validateEmail(searchKey);
    console.log(email);
    email === true
      ? setSearchKey(searchKey.toLowerCase())
      : setSearchKey(searchKey.toUpperCase());
    //setSearchKey(search)
    setIsLoading(true);
    setPagenumber(0);
    shouldShowSearchFailDialogRef.current = true;
    setShowNoRecordsMessage(false);
    setSearchFlag(!searchFlag);
  };

  //clear search
  const clearSearch = () => {
    setSearchKey("");
    setPagenumber(0);
    setViewList([]);
    setTotalPages(0);
    setSourceTypeFilter([]);
    setSyncStatusFilter([]);
    setParkingIdFilter([]);
    setFromDate(null);
    setToDate(null);
    setOrganizationName("");
    setHasInteracted(false);
    setIsReportEnabled(false);
    //reload the default page after clearing search and filters
    shouldShowSearchFailDialogRef.current = false;
    setIsLoading(true);
    httpRequest.get(
      "tempAccessListView",
      {
        "Content-Type": "application/json",
      },
      successCallbackList,
      errorCallbackList,
      {
        page: 0,
        size: postsPerPage,
        searchData: "",
        sourceType: [],
        syncStatus: [],
        parkingIds: [],
        startDate: "",
        endDate: "",
      }
    );
  };

  // clear table and disable buttons only when search is cleared
  // (toggling the Source/Sync Status dropdowns should not hide or reload the table)
  useEffect(() => {
    if (
      searchKey === "" &&
      sourceTypeFilter.length === 0 &&
      syncStatusFilter.length === 0 &&
      parkingIdFilter.length === 0 &&
      fromDate === null &&
      toDate === null
    ) {
      setViewList([]);
      setTotalPages(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey]);

  //close search fail dialog
  const closeSearchFail = () => {
    const hadSearchParams = hasActiveFilters();
    setDialogOpen(false);
    setResponseDataNotFound("");
    setresponseType("");
    setSearchKey("");
    setSourceTypeFilter([]);
    setSyncStatusFilter([]);
    setParkingIdFilter([]);
    setFromDate(null);
    setToDate(null);
    setHasInteracted(false);
    setIsReportEnabled(false);
    shouldShowSearchFailDialogRef.current = false;
    // already on the default/empty list — do not refetch, or the dialog loops
    if (!hadSearchParams) {
      setIsLoading(false);
      setShowNoRecordsMessage(true);
      return;
    }
    //reload the default page after closing the search fail dialog
    setIsLoading(true);
    httpRequest.get(
      "tempAccessListView",
      {
        "Content-Type": "application/json",
      },
      successCallbackList,
      errorCallbackList,
      {
        page: 0,
        size: postsPerPage,
        searchData: "",
        sourceType: [],
        syncStatus: [],
        parkingIds: [],
        startDate: "",
        endDate: "",
      }
    );
  };

  const handleGenerate = () => {
    if (isInvalidDateRange()) {
      showInvalidDateRangeError();
      return;
    }
    setIsLoading(true);
    setPagenumber(0);
    setIsReportEnabled(true);
    shouldShowSearchFailDialogRef.current = true;
    setShowNoRecordsMessage(false);
    getTempAccessList(0);
  };

  const handleSourceTypeChange = (event) => {
    setHasInteracted(true);
    const {
      target: { value },
    } = event;
    const selectedValues = typeof value === "string" ? value.split(",") : value;
    if (selectedValues.includes("1") && !sourceTypeFilter.includes("1")) {
      setSourceTypeFilter([
        ...accessControlManagementFilters.sourceType.map(
          (source) => source.uid
        ),
      ]);
    } else if (
      !selectedValues.includes("1") &&
      sourceTypeFilter.includes("1")
    ) {
      setSourceTypeFilter([]);
    } else if (selectedValues.includes("1") && sourceTypeFilter.includes("1")) {
      setSourceTypeFilter([...selectedValues.filter((value) => value !== "1")]);
    } else if (
      !selectedValues.includes("1") &&
      !sourceTypeFilter.includes("1")
    ) {
      if (
        selectedValues.length ===
        accessControlManagementFilters.sourceType.length - 1
      ) {
        setSourceTypeFilter(["1", ...selectedValues]);
      } else {
        setSourceTypeFilter([...selectedValues]);
      }
    }
  };

  const handleSyncStatusChange = (event) => {
    setHasInteracted(true);
    const {
      target: { value },
    } = event;
    const selectedValues = typeof value === "string" ? value.split(",") : value;
    if (selectedValues.includes("1") && !syncStatusFilter.includes("1")) {
      setSyncStatusFilter([
        ...accessControlManagementFilters.syncStatus.map((sync) => sync.uid),
      ]);
    } else if (
      !selectedValues.includes("1") &&
      syncStatusFilter.includes("1")
    ) {
      setSyncStatusFilter([]);
    } else if (selectedValues.includes("1") && syncStatusFilter.includes("1")) {
      setSyncStatusFilter([...selectedValues.filter((value) => value !== "1")]);
    } else if (
      !selectedValues.includes("1") &&
      !syncStatusFilter.includes("1")
    ) {
      if (
        selectedValues.length ===
        accessControlManagementFilters.syncStatus.length - 1
      ) {
        setSyncStatusFilter(["1", ...selectedValues]);
      } else {
        setSyncStatusFilter([...selectedValues]);
      }
    }
  };

  const handlePageSizeChange = (event) => {
    setPagenumber(0);
    setpostsPerPage(Number(event.target.value));
  };

  const handleParkingChange = (event) => {
    setHasInteracted(true);
    const {
      target: { value },
    } = event;
    const selectedValues = typeof value === "string" ? value.split(",") : value;
    if (selectedValues.includes("all") && !parkingIdFilter.includes("all")) {
      setParkingIdFilter(["all", ...allParkingIds]);
    } else if (
      !selectedValues.includes("all") &&
      parkingIdFilter.includes("all")
    ) {
      setParkingIdFilter([]);
    } else if (
      selectedValues.includes("all") &&
      parkingIdFilter.includes("all")
    ) {
      setParkingIdFilter(selectedValues.filter((v) => v !== "all"));
    } else if (selectedValues.length === allParkingIds.length) {
      setParkingIdFilter(["all", ...selectedValues]);
    } else {
      setParkingIdFilter(selectedValues);
    }
  };

  const handleFromDateChange = (date) => {
    setHasInteracted(true);
    setFromDate(date);
    if (toDate && date && new Date(toDate) < new Date(date)) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    setHasInteracted(true);
    setToDate(date);
  };

  const getSourceTypeRenderValue = (selectedValues) => {
    if (!selectedValues || selectedValues.length === 0) {
      return "Select Source";
    }
    if (selectedValues.includes("1")) {
      return accessControlManagementFilters.sourceType.find(
        (source) => source.uid === "1"
      ).name;
    } else {
      return selectedValues
        .map(
          (uid) =>
            accessControlManagementFilters.sourceType.filter(
              (source) => source.uid === uid
            )[0]?.name
        )
        .join(", ");
    }
  };

  const getSyncStatusRenderValue = (selectedValues) => {
    if (!selectedValues || selectedValues.length === 0) {
      return "Select Sync Status";
    }
    if (selectedValues.includes("1")) {
      return accessControlManagementFilters.syncStatus.find(
        (source) => source.uid === "1"
      ).name;
    } else {
      return selectedValues
        .map(
          (uid) =>
            accessControlManagementFilters.syncStatus.filter(
              (source) => source.uid === uid
            )[0]?.name
        )
        .join(", ");
    }
  };

  const getParkingRenderValue = (selectedValues) => {
    if (!selectedValues || selectedValues.length === 0) {
      return "Select Parking";
    }
    if (selectedValues.includes("all")) {
      return "All";
    }
    return parkingSpaceList
      .filter((parking) => selectedValues.includes(parking.parkingId))
      .map((parking) => parking.name)
      .join(", ");
  };

  const handleResync = (row) => {
    setIsLoading(true);
    setSyncMode("single");
    httpRequest.patch(
      "syncVehicleData",
      {
        vehicleNumber: row?.vehicleNumber,
        bulkSync: false,
      },
      {},
      successCallbacksync,
      errorCallbacksync,
      {}
    );
  }

  const handleResyncAll = () => {
    setIsLoading(true);
    setSyncMode("bulk");
    httpRequest.patch(
      "syncVehicleData",
      {
        bulkSync: true,
      },
      {},
      successCallbacksync,
      errorCallbacksync,
      {}
    );
  }

  // stop the bulk download polling interval
  const stopBulkDownloadPolling = () => {
    if (pollIntervalRef.current) {
      clearInterval(pollIntervalRef.current);
      pollIntervalRef.current = null;
    }
  };

  // trigger the browser download for the received xlsx blob
  const triggerFileDownload = (response) => {
    const disposition = response.headers["content-disposition"] || "";
    let fileName = "VehicleAccessReport.xlsx";
    if (disposition.includes("filename=")) {
      fileName = disposition
        .split("filename=")[1]
        .replace(/["']/g, "")
        .trim();
    }
    const fileType = response.headers["content-type"];
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(
        new Blob([response.data], { type: fileType }),
        fileName
      );
    } else {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
  };

  // poll the bulk download job and download the file once ready
  const pollBulkDownloadJob = (jobId) => {
    axios({
      url: UrlConfig("bulkDownloadJob", { jobId }),
      method: "GET",
      responseType: "blob",
      headers: {
        realmname: getCookie("realmName"),
        Authorization: "bearer " + getCookie("auth"),
      },
    })
      .then(async (response) => {
        const contentType = response.headers["content-type"] || "";
        // xlsx file is ready -> download and stop polling
        if (
          contentType.includes("spreadsheetml") ||
          contentType.includes("officedocument")
        ) {
          triggerFileDownload(response);
          stopBulkDownloadPolling();
          sessionStorage.removeItem(BULK_JOB_STORAGE_KEY);
          // stop the progress animation only once the excel download has started
          setIsReportDownloading(false);
          return;
        }
        // 202 -> job still in progress, keep polling
        if (response.status === 202) {
          return;
        }
        // JSON 200 response -> check whether the job failed
        let parsed = {};
        try {
          parsed = JSON.parse(await response.data.text());
        } catch (e) {
          parsed = {};
        }
        if (
          parsed.status &&
          String(parsed.status).toUpperCase().includes("FAIL")
        ) {
          stopBulkDownloadPolling();
          sessionStorage.removeItem(BULK_JOB_STORAGE_KEY);
          setIsReportDownloading(false);
          props.dispatch(
            updateToasterConfig({
              show: true,
              message: parsed.message || "Bulk export failed for this job.",
              color: "red",
            })
          );
        }
        // any other in-progress status -> keep polling
      })
      .catch(() => {
        stopBulkDownloadPolling();
        sessionStorage.removeItem(BULK_JOB_STORAGE_KEY);
        setIsReportDownloading(false);
        props.dispatch(
          updateToasterConfig({
            show: true,
            message: "Unable to download report, please try again.",
            color: "red",
          })
        );
      });
  };

  // start polling the bulk download job every 5 seconds
  const startBulkDownloadPolling = (jobId) => {
    stopBulkDownloadPolling();
    setIsReportDownloading(true);
    pollBulkDownloadJob(jobId);
    pollIntervalRef.current = setInterval(() => {
      pollBulkDownloadJob(jobId);
    }, 5000);
  };

  // success callback for generate bulk download -> store jobId and start polling
  const successGenerateBulkDownload = (jsonResponse) => {
    const jobId = jsonResponse?.data?.jobId;
    if (jobId) {
      sessionStorage.setItem(BULK_JOB_STORAGE_KEY, jobId);
      startBulkDownloadPolling(jobId);
    } else {
      setIsReportDownloading(false);
      props.dispatch(
        updateToasterConfig({
          show: true,
          message: "Unable to generate report, please try again.",
          color: "red",
        })
      );
    }
  };

  // error callback for generate bulk download
  const errorGenerateBulkDownload = () => {
    setIsReportDownloading(false);
    props.dispatch(
      updateToasterConfig({
        show: true,
        message: "Unable to generate report, please try again.",
        color: "red",
      })
    );
  };

  // called from the Report button -> generate the report and start polling
  const handleReportDownload = () => {
    if (isReportDownloading) return;
    if (isInvalidDateRange()) {
      showInvalidDateRangeError();
      return;
    }
    setIsReportDownloading(true);
    const listParams = buildListParams(0);
    httpRequest.get(
      "generateBulkDownload",
      {
        "Content-Type": "application/json",
      },
      successGenerateBulkDownload,
      errorGenerateBulkDownload,
      {
        searchData: listParams.searchData,
        sourceType: listParams.sourceType,
        syncStatus: listParams.syncStatus,
        parkingIds: listParams.parkingIds,
        startDate: listParams.startDate,
        endDate: listParams.endDate,
      }
    );
  };

  // resume an in-progress bulk download job after a page refresh
  useEffect(() => {
    const savedJobId = sessionStorage.getItem(BULK_JOB_STORAGE_KEY);
    if (savedJobId) {
      startBulkDownloadPolling(savedJobId);
    }
    return () => stopBulkDownloadPolling();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoading && <Loader />}
        <Grid container direction="column" className={classes.container}>
            {organizationName ? (
              <Typography className={classes.organizationTitle}>
                Organization: {organizationName}
              </Typography>
            ) : null}
            <Grid
              container
              direction="row"
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.header}
              style={{ marginTop: organizationName ? "0.5%" : "1%" }}
            >
              <Grid
                item
                xs={10}
                sm={10}
                md={10}
                lg={10}
                style={{ display: "flex", gap: "1rem", alignItems: "flex-end", flexWrap: "wrap" }}
              >
                <div className="ParkingOverview-navbar__wrapper_nav_left">
                  <div className="ParkingOverview-navbar__wrapper_nav_left_searchicon sIconC">
                    {(searchKey === "" || searchKey?.length < 3) && (
                      <SearchIcon />
                    )}
                  </div>
                  <div className="ParkingOverview-navbar__wrapper_nav_left_search">
                    <input
                      placeholder="Email Id or Vehicle Number"
                      value={searchKey}
                      onChange={handleSearchKeyChange}
                      ref={inputRef}
                      disabled={responseDataNotFound !== "" ? true : false}
                    />
                    {searchKey?.length > 2 && (
                      <p
                        className={
                          searchKey === "" ? "editcross" : "input__cross"
                        }
                        onClick={handleSearchKey}
                      >
                        <SearchIcon />
                      </p>
                    )}
                    {searchKey !== "" && (
                      <p className={"input__cross_x"} onClick={clearSearch}>
                        <ClearIcon />
                      </p>
                    )}
                  </div>
                </div>
                <div>
                  <div className="dropdown-title">Source</div>
                  <Select
                    multiple
                    displayEmpty
                    className={classes.select}
                    MenuProps={{
                      classes: {
                        paper: classes.menuPaper,
                      },
                    }}
                    sx={{ width: 150 }}
                    onChange={handleSourceTypeChange}
                    value={sourceTypeFilter}
                    renderValue={(selected) =>
                      getSourceTypeRenderValue(selected)
                    }
                    input={<OutlinedInput />}
                  >
                    {accessControlManagementFilters.sourceType.map((source) => (
                      <MenuItem
                        key={source.uid}
                        value={source.uid}
                        className={classes.filterListItem}
                      >
                        <ListItemText primary={source.name} />
                        <Checkbox
                          className={classes.filterCheckbox}
                          checked={
                            sourceTypeFilter.includes(source.uid) ||
                            sourceTypeFilter.includes("1")
                          }
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div>
                  <div className="dropdown-title">Sync Status</div>
                  <Select
                    multiple
                    displayEmpty
                    className={classes.select}
                    MenuProps={{
                      classes: {
                        paper: classes.menuPaper,
                      },
                    }}
                    sx={{ width: 150 }}
                    onChange={handleSyncStatusChange}
                    value={syncStatusFilter}
                    renderValue={(selected) => getSyncStatusRenderValue(selected)}
                    input={<OutlinedInput />}
                  >
                    {accessControlManagementFilters.syncStatus.map((sync) => (
                      <MenuItem
                        key={sync.uid}
                        value={sync.uid}
                        className={classes.filterListItem}
                      >
                        <ListItemText primary={sync.name} />
                        <Checkbox
                          className={classes.filterCheckbox}
                          checked={
                            syncStatusFilter.includes(sync.uid) ||
                            syncStatusFilter.includes("1")
                          }
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div>
                  <div className="dropdown-title">Parking Space</div>
                  <Select
                    multiple
                    displayEmpty
                    className={classes.parkingSelect}
                    MenuProps={{
                      classes: {
                        paper: classes.menuPaper,
                      },
                    }}
                    value={parkingIdFilter}
                    onChange={handleParkingChange}
                    input={<OutlinedInput />}
                    renderValue={(selected) => getParkingRenderValue(selected)}
                  >
                    <MenuItem value="all" className={classes.filterListItem}>
                      <ListItemText primary="All" />
                      <Checkbox
                        className={classes.filterCheckbox}
                        checked={parkingIdFilter.includes("all")}
                      />
                    </MenuItem>
                    {parkingSpaceList.map((parking) => (
                      <MenuItem
                        key={parking.parkingId}
                        value={parking.parkingId}
                        className={classes.filterListItem}
                      >
                        <ListItemText primary={parking.name} />
                        <Checkbox
                          className={classes.filterCheckbox}
                          checked={
                            parkingIdFilter.includes(parking.parkingId) ||
                            parkingIdFilter.includes("all")
                          }
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div className={classes.datePickerWrap}>
                  <div className={classes.dateLabel}>From Date</div>
                  <div className={classes.datePickerField}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                        autoOk
                        InputProps={{
                          disableUnderline: true,
                          className: classes.datePickerInput,
                        }}
                        disableFuture
                        onKeyDown={(e) => e.preventDefault()}
                        variant="inline"
                        value={fromDate}
                        onChange={handleFromDateChange}
                        format="DD/MM/yyyy"
                        placeholder="DD/MM/YYYY"
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
                <div className={classes.datePickerWrap}>
                  <div className={classes.dateLabel}>To Date</div>
                  <div className={classes.datePickerField}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                        autoOk
                        InputProps={{
                          disableUnderline: true,
                          className: classes.datePickerInput,
                        }}
                        disableFuture
                        minDate={fromDate || undefined}
                        onKeyDown={(e) => e.preventDefault()}
                        variant="inline"
                        value={toDate}
                        onChange={handleToDateChange}
                        format="DD/MM/yyyy"
                        placeholder="DD/MM/YYYY"
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
                <div>
                  <button
                    type="button"
                    className={classes.createuserButton}
                    disabled={!hasActiveFilters()}
                    style={{
                      opacity: !hasActiveFilters() ? 0.5 : 1,
                      cursor: !hasActiveFilters() ? "not-allowed" : "pointer",
                    }}
                    onClick={handleGenerate}
                  >
                    Generate
                  </button>
                </div>
                {
                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  <button
                    type="button"
                    className={classes.createuserButton}
                    disabled={!isReportEnabled || viewList.length === 0 || isReportDownloading}
                    style={{ opacity: (!isReportEnabled || viewList.length === 0 || isReportDownloading) ? 0.5 : 1, cursor: (!isReportEnabled || viewList.length === 0 || isReportDownloading) ? 'not-allowed' : 'pointer' }}
                    onClick={handleReportDownload}
                  >
                    Report&nbsp;&nbsp;
                    <img
                      className={classes.downloadIcon}
                      src={Download}
                      alt=""
                    />
                  </button>
                  {isReportDownloading && (
                    <CircularProgress
                      size={22}
                      thickness={5}
                      style={{ color: "#03A9F3" }}
                    />
                  )}
                </div>
                }
              </Grid>

              <Grid
                className="action-buttons"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
                item
                xs={2}
                sm={2}
                md={2}
                lg={2}
              >
                <div>
                  <button
                    type="button"
                    className={classes.createuserButton}
                    onClick={uploadHandler}
                  >
                    Upload Vehicles&nbsp;
                     <img
                      className={classes.addIcon}
                      src={add}
                      alt=""
                    />
                  </button>
                </div>
              </Grid>
              {searchKey !== "" && searchKey?.length < 3 && (
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <p className={classes.searchVal}>
                    Enter at least 3 characters to initiate search
                  </p>
                </Grid>
              )}
            </Grid>
          {(viewList.length > 0 || showNoRecordsMessage) && (
          <React.Fragment>
            <Grid item className={classes.aboveTableGrid}>
              <Grid
                container
                direction="row"
                justify="center"
                className={classes.tableGrid}
              >
                <TableContainer className={classes.paper} component={Paper}>
                  <Table className={classes.table} aria-label="View table">
                    <EnhancedTableHead
                      classes={classes}
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                    />

                    <TableBody>
                      {viewList.length > 0 ? (
                        viewList.map((row, index) => {
                          let no = index;
                          function formatNo(no) {
                            return pageNumber * postsPerPage + no;
                          }
                          return (
                            <TableRow key={index}>
                              <TableCell
                                className={classes.tableCell}
                                align="center"
                              >
                                {formatNo(no + 1)}
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                align="left"
                              >
                                {Array.isArray(row?.parkingNames) &&
                                row.parkingNames.length > 0
                                  ? row.parkingNames.join(", ")
                                  : Array.isArray(row?.parkingSpaces) &&
                                    row.parkingSpaces.length > 0
                                  ? row.parkingSpaces.join(", ")
                                  : "--"}
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                align="left"
                              >
                                {row?.emailId ? row?.emailId : "--"}
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                align="left"
                              >
                                <grid>
                                  {row?.vehicleNumber
                                    ? row?.vehicleNumber
                                    : "--"}
                                </grid>

                                <br />
                                <grid>
                                  {row?.vehicleType?.name
                                    ? row?.vehicleType.name
                                    : "--"}
                                </grid>
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                align="left"
                              >
                                {row?.lastUpdatedTime
                                  ? row?.lastUpdatedTime
                                  : "--"}
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                align="left"
                              >
                                {row?.source ? row?.source : "--"}
                              </TableCell>

                              <TableCell
                                className={classes.tableCell}
                                style={{ textAlign: "center" }}
                                align="center"                                
                              >
                                {Number(row?.syncStatus) === 1 ? (
                                  <img
                                    alt="synced"
                                    src={synced}
                                    className={classes.edit_icon}
                                  />
                                ) : Number(row?.syncStatus) === 2 ? (
                                  <img
                                    alt="not_synced"
                                    src={notSynced}
                                    className={classes.edit_icon}
                                  />
                                ) : Number(row?.syncStatus) === 0 ? (
                                  <img
                                    alt="sync_pending"
                                    src={syncPending}
                                    className={classes.edit_icon}
                                  />
                                ) : (
                                  "--"
                                )}                               
                              </TableCell>
                              <TableCell className={classes.thDataSyncCall}>
                                {[0,2].includes(Number(row?.syncStatus)) ? (
                                  <IconButton
                                    aria-label="sync"
                                    className={classes.resyncButton}
                                    onClick={() => handleResync(row)}
                                  >
                                    <img
                                      alt="sync"
                                      src={syncImage}
                                      className={classes.edit_icon}
                                    />
                                  </IconButton>
                                ) : null}
                              </TableCell>
                              <TableCell className={classes.viewTableCell}>
                                <Button
                                  className={classes.viewButton}
                                  onClick={() =>
                                    viewHandler(
                                      row.vehicleNumber
                                        ? row.vehicleNumber
                                        : "",
                                      row?.userId
                                    )
                                  }
                                >
                                  View
                                </Button>
                                {row?.source === "BULK_UPLOAD" && (
                                  <img
                                    alt="delete_icon"
                                    src={deleteIcon}
                                    className={classes.delete_icon}
                                    onClick={() =>
                                      deleteHandler(
                                        row?.accessControlId,
                                        row?.vehicleNumber
                                      )
                                    }
                                  />
                                )}
                                {row?.source === "BULK_UPLOAD" && row?.userId === getCookie("userId") && (
                                  <img
                                    alt="edit_icon"
                                    src={EditIcon}
                                    className={classes.edit_icon}
                                    onClick={() => {
                                      props.history.push({
                                        pathname: "/portal/tempaccessedit",
                                        state: {
                                          accessControlId: row.vehicleNumber
                                            ? row.vehicleNumber
                                            : "",
                                          page: pageNumber,
                                          searchKey: searchKey,
                                        },
                                      });
                                    }}
                                  />
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={tempAccessListHeaderCell.length}
                            align="center"
                            className={classes.tableCell}
                            style={{ padding: "48px 16px" }}
                          >
                            No records found
                          </TableCell>
                        </TableRow>

                        // <Dialog
                        //   open={dialogOpen}
                        //   onClose={() => {
                        //     setDialogOpen(false);
                        //     setresponseType("");
                        //   }}
                        //   PaperProps={{
                        //     style: {
                        //       padding: "1% 2%",
                        //       width: "425px",
                        //     },
                        //   }}
                        //   className={classes.dialog}
                        // >
                        //   <MuiDialogTitle
                        //     style={{
                        //       paddingBottom: "8px",
                        //       paddingTop: "2px",
                        //       paddingLeft: "2px",
                        //       paddingRight: "2px",
                        //     }}
                        //   >
                        //     <Grid
                        //       container
                        //       direction="row"
                        //       justify="space-between"
                        //     >
                        //       <Grid item>
                        //         <span className={classes.dialogHeader}>
                        //           Alert
                        //         </span>
                        //       </Grid>
                        //     </Grid>
                        //   </MuiDialogTitle>
                        //   <Divider />
                        //   <DialogContent
                        //     style={{ paddingLeft: "0px", paddingRight: "0px" }}
                        //   >
                        //     <Grid item>
                        //       <Grid
                        //         container
                        //         direction="column"
                        //         justify="center"
                        //       >
                        //         <Grid item>
                        //           <Typography>
                        //             We can't find any results matching your
                        //             search. Kindly try with a different keyword.
                        //           </Typography>
                        //         </Grid>
                        //       </Grid>
                        //     </Grid>
                        //   </DialogContent>
                        //   <DialogActions>
                        //     <Grid item>
                        //       <Grid
                        //         container
                        //         direction="row"
                        //         justify="flex-end"
                        //         className={classes.dialogActionGrid}
                        //       >
                        //         <Grid item className={classes.dialogCancelGrid}>
                        //           <button
                        //             type="button"
                        //             onClick={closeSearchFail}
                        //             className={classes.dialogConfirm}
                        //           >
                        //             OK
                        //           </button>
                        //         </Grid>
                        //       </Grid>
                        //     </Grid>
                        //   </DialogActions>
                        // </Dialog>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
            {viewList.length > 0 && (
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className={classes.paginationOuterGrid}
            >
              <Grid item>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item>
                    <div>Number of items in the Page:</div>
                  </Grid>
                  <Grid item>
                    <Select
                      onChange={handlePageSizeChange}
                      className={classes.paginationSelect}
                      MenuProps={{
                        classes: {
                          paper: classes.menuPaper,
                        },
                      }}
                      sx={{ width: 65 }}
                      value={postsPerPage}
                      input={<OutlinedInput />}
                    >
                      {accessControlManagementFilters.pageSizes.map((size) => (
                        <MenuItem
                          key={size}
                          value={size}
                          sx={{
                            justifyContent: "center",
                            textAlign: "center",
                          }}
                          className={classes.filterListItem}
                        >
                          <ListItemText primary={size} />
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justify="flex-end"
                  className={classes.paginationStyle}
                >
                  <Grid item>
                    <Pagination
                      count={totalPages}
                      page={pageNumber + 1}
                      className={classes.root}
                      size="small"
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            )}
          </React.Fragment>
          )}

          {responseType === "success" && (
            <Dialog
              open={dialogOpen}
              onClose={() => {
                setDialogOpen(false);
                setresponseType("");
              }}
              PaperProps={{
                style: {
                  padding: "1.5% 3%",
                },
              }}
              className={classes.dialog}
            >
              <MuiDialogTitle
                style={{
                  paddingBottom: "8px",
                  paddingTop: "2px",
                  paddingLeft: "2px",
                  paddingRight: "2px",
                }}
              >
                <Grid container direction="row" justify="space-between">
                  <Grid item>
                    <span className={classes.dialogHeader}>
                      Vehicle Access Data Manual Sync
                    </span>
                  </Grid>
                </Grid>
              </MuiDialogTitle>
              <Divider />
              <DialogContent
                style={{ paddingLeft: "0px", paddingRight: "0px" }}
              >
                <Grid container direction="column" justify="center">
                  {falseList === 0 && (
                    <Grid item>
                      <p>
                        <span className={classes.dialogSubTextPass}>
                          {syncMode === "bulk"
                            ? `${syncTotalRecords} vehicle is processed to Sync`
                            : syncResponseMessage}
                        </span>
                      </p>
                    </Grid>
                  )}
                  {falseList > 0 && (
                    <>
                      <Grid item>
                        <p>
                          <span className={classes.dialogSubTitle}>
                            Number of vehicles Failed to Sync:
                          </span>{" "}
                          <span className={classes.dialogSubTextFail}>
                            {syncfail}
                          </span>
                        </p>
                      </Grid>
                      <Grid item>
                        <p>
                          <span className={classes.dialogSubTitle}>
                            Number of Vehicles Synced Successfully:
                          </span>{" "}
                          <span className={classes.dialogSubTextPass}>
                            {syncpass}
                          </span>
                        </p>
                      </Grid>
                    </>
                  )}
                </Grid>
              </DialogContent>
              <DialogActions>
                <Grid item>
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    className={classes.dialogActionGrid}
                  >
                    {falseList === 0 && (
                      <Grid item className={classes.dialogCancelGrid}>
                        <button
                          type="button"
                          onClick={() => {
                            setDialogOpen(false);
                            setresponseType("");
                          }}
                          className={classes.dialogConfirm}
                        >
                          OK
                        </button>
                      </Grid>
                    )}
                    {falseList > 0 && (
                      <Grid item className={classes.dialogCancelGrid}>
                        <button
                          type="button"
                          onClick={() => {
                            closeRefresh();
                          }}
                          className={classes.dialogConfirm}
                        >
                          OK
                        </button>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </DialogActions>
            </Dialog>
          )}
          {responseType === "fail" && (
            <Dialog
              open={dialogOpen}
              onClose={() => {
                setDialogOpen(false);
                setresponseType("");
              }}
              PaperProps={{
                style: {
                  padding: "1.5% 3%",
                },
              }}
              className={classes.dialog}
            >
              <MuiDialogTitle
                style={{
                  paddingBottom: "8px",
                  paddingTop: "2px",
                  paddingLeft: "2px",
                  paddingRight: "2px",
                }}
              >
                <Grid container direction="row" justify="space-between">
                  <Grid item>
                    <span className={classes.dialogHeader}>
                      Vehicle Access Manual Sync
                    </span>
                  </Grid>
                </Grid>
              </MuiDialogTitle>
              <Divider />
              <DialogContent
                style={{ paddingLeft: "0px", paddingRight: "0px" }}
              >
                <Grid item>
                  <Grid container direction="column" justify="center">
                    <Grid item>
                      <Typography className={classes.dialogSubHeaderError}>
                        Vehicle Access Data Sync Failed, Please try Again
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Grid item>
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    className={classes.dialogActionGrid}
                  >
                    <Grid item className={classes.dialogCancelGrid}>
                      <button
                        type="button"
                        onClick={() => {
                          setDialogOpen(false);
                          setresponseType("");
                        }}
                        className={classes.dialogConfirm}
                      >
                        OK
                      </button>
                    </Grid>
                  </Grid>
                </Grid>
              </DialogActions>
            </Dialog>
          )}
          {dialogOpen && responseType === "" && (
            <Dialog
              open={dialogOpen}
              onClose={() => {
                setDialogOpen(false);
                setresponseType("");
                setDeleteId([]);
              }}
              PaperProps={{
                style: {
                  padding: "1.5% 3%",
                },
              }}
              className={classes.dialog}
            >
              <MuiDialogTitle
                style={{
                  paddingBottom: "8px",
                  paddingTop: "2px",
                  paddingLeft: "2px",
                  paddingRight: "2px",
                }}
              >
                <Grid container direction="row" justify="space-between">
                  <Grid item>
                    <span className={classes.dialogHeader}>
                      Remove Vehicle Access
                    </span>
                  </Grid>
                </Grid>
              </MuiDialogTitle>
              <Divider />
              <DialogContent
                style={{ paddingLeft: "0px", paddingRight: "0px" }}
              >
                <Grid item>
                  <Grid container direction="column" justify="center">
                    <Grid item>
                      <Typography className={classes.dialogSubHeader}>
                        Select the parking spaces to remove Vehicle access
                      </Typography>
                    </Grid>
                    {parkList.map((item) => {
                      return (
                        <Grid container>
                          <Checkbox
                            color="default"
                            size="small"
                            type="checkbox"
                            data-target="filter"
                            onChange={() =>
                              deleteParkingHandler(item?.parkingId)
                            }
                          />
                          <span
                            className={classes.dialogSubTitle}
                            style={{ alignSelf: "center" }}
                          >
                            {item.parkingName}
                          </span>
                          <br />
                          <span className={classes.dialogAddress}>
                            {"(" + item.parkingAddress + ".)"}
                          </span>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Grid item>
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    className={classes.dialogActionGrid}
                  >
                    <Grid item className={classes.dialogCancelGrid}>
                      <button
                        type="button"
                        onClick={() => {
                          setDialogOpen(false);
                          setDeleteId([]);
                        }}
                        className={classes.dialogCancel}
                      >
                        Cancel
                      </button>
                    </Grid>
                    <Grid item className={classes.dialogConfirmGrid}>
                      <button
                        type="button"
                        disabled={deleteId.length === 0}
                        style={{
                          backgroundColor:
                            deleteId.length === 0 ? "#A2A2A2" : "#03A9F3",
                        }}
                        className={classes.dialogConfirm}
                        onClick={submitDetails}
                      >
                        Confirm
                      </button>
                    </Grid>
                  </Grid>
                </Grid>
              </DialogActions>
            </Dialog>
          )}
          {responseType === "searchFail" && (
              <Dialog
                open={dialogOpen}
                onClose={() => {
                  setDialogOpen(false);
                  setresponseType("");
                }}
                PaperProps={{
                  style: {
                    padding: "1% 2%",
                    width: "425px",
                  },
                }}
                className={classes.dialog}
              >
                <MuiDialogTitle
                  style={{
                    paddingBottom: "8px",
                    paddingTop: "2px",
                    paddingLeft: "2px",
                    paddingRight: "2px",
                  }}
                >
                  <Grid container direction="row" justify="space-between">
                    <Grid item>
                      <span className={classes.dialogHeader}>Alert</span>
                    </Grid>
                  </Grid>
                </MuiDialogTitle>
                <Divider />
                <DialogContent
                  style={{ paddingLeft: "0px", paddingRight: "0px" }}
                >
                  <Grid item>
                    <Grid container direction="column" justify="center">
                      <Grid item>
                        <Typography>
                          We can't find any results matching your search. Kindly
                          try with a different keyword.
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Grid item>
                    <Grid
                      container
                      direction="row"
                      justify="flex-end"
                      className={classes.dialogActionGrid}
                    >
                      <Grid item className={classes.dialogCancelGrid}>
                        <button
                          type="button"
                          onClick={closeSearchFail}
                          className={classes.dialogConfirm}
                        >
                          OK
                        </button>
                      </Grid>
                    </Grid>
                  </Grid>
                </DialogActions>
              </Dialog>
            )}
        </Grid>
    </>
  );
}
//  redux state method
// const mapStateToProps = (state) => {
//   return {
//       pageRedirect : state.app.pageRedirect
//   }
// }

//redux dispatch method
const mapDispatchToProps = (dispatch) => ({
  updateBreadcrumbs,
  updateToasterConfig,
  dispatch,
});

export default withRouter(
  connect(null, mapDispatchToProps)(TempAccessListView)
);